/**
 * keyCode常量，与KeyboardEvent.key对应。
 * KeyboardEvent.keyCode已经被废弃
 * @type {string}
 */
export const ARROW_UP = 'ArrowUp';
export const ARROW_DOWN = 'ArrowDown';
export const ENTER = 'Enter';
export const TAB = 'Tab';

/**
 * @desc 比较两个keyCode是不是一致
 * @param code1
 * @param code2
 * @return {boolean} 一致返回true, 否者返回false
 */
export function compareKeyCode (code1, code2) {
  return code1 === code2;
}

/**
 * 判断一个
 * @param event
 * @return {boolean}
 */
export function isEnter (event) {
  const key = event.key;
  if (!key) {
    return false;
  }
  return compareKeyCode(key, ENTER);
}
